'use client';
import React from 'react';
import { ProductDescription as SharedProductDescription } from '@launchstore/shared-puck';
import type { ProductDescriptionProps } from '@launchstore/shared-puck';
import { useProduct } from '@/lib/hooks/useProduct';
import type { ProductData } from '@launchstore/shared-puck';

const toProductData = (p: any): ProductData | null => {
  if (!p) return null;
  return {
    id: p.id, title: p.title, description: p.description, handle: p.handle,
    material: p.material, weight: p.weight, length: p.length, width: p.width, height: p.height,
    origin_country: p.origin_country, metadata: p.metadata,
    variants: (p.variants || []).map((v: any) => ({
      id: v.id, sku: v.sku, weight: v.weight, length: v.length, width: v.width, height: v.height,
    })),
  };
};

const SharedProductDescriptionRender = (SharedProductDescription as any).render;

const ProductDescriptionImpl: React.FC<ProductDescriptionProps> = (props: any) => {
  const { product } = useProduct();
  return <SharedProductDescriptionRender {...(props as any)} product={toProductData(product)} />;
};

export const ProductDescription: any = { ...SharedProductDescription, render: (props: any) => <ProductDescriptionImpl {...props} /> };
export default ProductDescription;
